import { createContext } from "react";

export const WrapParentContext = createContext(null);